import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { m } from 'framer-motion'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { SectorData } from './NposSector'
import { ImageComp } from '../../ImageCompo/ImageComp'
import "./NposSectors.css"
import { ParagraphComp } from '../../ParagraphComp/ParagraphComp'
const NposSectors = () => {
    return (
        <>
            <m.section className=" py-[70px] max-sm:py-[70px] lg:py-[70px] md:py-[70px] sm:py-[70px] xs;py-[50px]" {...fadeIn}>
                <Container>
                    <Row className=''>
                        <Col className="mb-[4%]">
                            <h6 className="font-extrabold text-black text-center max-sm:text-3xl text-4xl mb-[25px] lg:mb-[15px]">Learn about the NPO Sector in India</h6>
                            <ParagraphComp className="max-sm:text-lg text-black lg:w-[85%] m-auto text-center">
                            GuideStar India conducted a pan India NPO Survey in FY 2022-23, the first of its kind in the country, to understand the dimensions of the NPO sector. This study was in partnership with the IIMA Research team as a part of India’s Million Missions, an initiative of CSO Coalition@75.
                            </ParagraphComp>
                        </Col>
                    </Row>
                    <Row className='row-cols-md-2'>
                        {SectorData.map(ele =>
                            <Col lg={4} className="px-[15px] md:mb-[15px]">
                                <div className="bg-lightgray p-[40px] flex flex-col gap-4 sm:p-[30px]">
                                    <div className='flex justify-center'>
                                        <ImageComp source={ele?.img} className="SectorDataImg max-sm:h-[180px]" />
                                    </div>
                                    <p className='text-base max-sm:text-base text-black font-medium tracking-wide text-justify'> {ele?.content}</p>
                                </div>
                            </Col>
                        )}
                    </Row>
                    <div className='w-[100%] flex justify-end'>
                        <a href="https://www.surveymonkey.com/r/MillionMissionsReport" target='_blank' rel='noreferrer' className='text-end pr-8 font-medium hover:text-blue-600 hover:underline transition'> Learn More</a>
                    </div>
                </Container>
            </m.section>

        </>
    )
}

export default NposSectors